import React, {
    useEffect,
} from "react";
import {useDispatch, useSelector} from 'react-redux';

import {
    Select,
    List,
    Button,
    Grid,
    Skeleton
} from 'antd';

import * as T from 'utils/types';
import TotalResult from "components/panel/TotalResult";
import { pubTabThunks } from "./PubTabSlice";
import Error500 from "components/errors/Error500";
import PublicationTitle from "components/publication/PublicationTitle";
import PublicationDescription from "components/publication/PublicationDescription";
import "./AltmetricBadge.css"
import searchPgUserInputsS from 'features/content/search_page/UserInputsSlice';

const {Option} = Select;

// publication tab
export default () => {
    const dispatch = useDispatch();


    useEffect(() => {
        // _altmetric_embed_init is offered by Altmetric in embeded.js file
        // this func will let js to find new altmetric-embed div and fetch the data for them
        // eslint-disable-next-line
        eval('if(typeof _altmetric_embed_init!="undefined"){_altmetric_embed_init();}');
    })

    const {
        searchInput,
        keywordType,
        facultyID,
        departmentID,
        searchTab,
        pubSpecific: { year, sortType }
    } = useSelector((state: T.RootState) => state.searchPgUserInputs);

    // below section is been commented because we decide to never sort the pubs acoording to rank (relevance)
    // we only sort based on either date or Altmetric score

    // // we do this because '-rank' can only be used when search using keywords
    // useEffect(()=>{
    //     if(sortType!=="-altmetric_score"){
    //         if(keywordType==="match" ){ // means search using name
    //             sortType!=="-date" && dispatch(searchPgUserInputsS.actions.setSortType("-date"));
    //         }
            
    //         if(keywordType==="search"){ // means search using keywords
    //             if(searchInput===''){ // if searchInput is empty, sort the pub using date
    //                 sortType!=="-date" && dispatch(searchPgUserInputsS.actions.setSortType("-date"));
    //             }else{ // if searchInput is not empty, sort the pub using rank
    //                 sortType!=="-rank" && dispatch(searchPgUserInputsS.actions.setSortType("-rank"));
    //             }
    //         }
    //     }
    // }, [dispatch, searchInput, keywordType, sortType]);

    const {
        total,
        status,
        hasNext,
        pubList,
        yearFilter:{ years, total:total_yearFilter, status: status_yearFilter}
    } = useSelector((state: T.RootState) => state.pubTab);



    useEffect(()=>{
        searchTab === T.SearchTab.PUBLICATIONS && dispatch(pubTabThunks.initList({
            keywordType, searchInput,
            facultyID, departmentID,
            year, sortType
        }));
    }, [
        keywordType, searchInput,
        facultyID, departmentID,
        year, sortType, dispatch, searchTab,
    ]);

    useEffect(()=>{
        dispatch(pubTabThunks.rPubYearStat({
            keywordType, searchInput,
            facultyID, departmentID,
        }));
    }, [
        keywordType, searchInput,
        facultyID, departmentID, dispatch
    ]);

    const screens = Grid.useBreakpoint();
    const breakpoint = screens.xs;

    return <>
        {total>=0&&status==="succeeded"&&<TotalResult searchResult={total}/>}




        {total_yearFilter>=0&&<Select
            className="sub-heading-font"
            value={year}
            style={{ width: 200, marginBottom: 4 }}
            onChange={ value => {
                dispatch(searchPgUserInputsS.actions.setYear(value));
            }}
            loading={status_yearFilter!=="succeeded"}
            disabled={status_yearFilter!=="succeeded"}
            filterOption={(input, option) => (option !== undefined) && 
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {[
                <Option className="sub-heading-font" value={-1} key={-1}>
                    {`All years (${total_yearFilter})`}
                </Option>,
                ...(years.map( x => 
                <Option className="sub-heading-font" value={x.year} key={x.year}>
                    {`${x.year} (${x.cnt})`}
                </Option>))
            ]}
        </Select>}

        {breakpoint && <br />}

        {/* 
            below section is been commented out because we decide to never sort the pubs acoording to rank (relevance)
            we only sort based on either date or Altmetric score 
        */}

        {/* {(searchInput===''||keywordType==="match")&&<Button
            type="text"
            style={{ fontSize: '13px', color: '#888' }}
            onClick={ () => {
                if (sortType !== '-date') {
                    dispatch(
                        searchPgUserInputsS.actions.setSortType('-date')
                    );
                }
            }}>
            Sort by date {sortType === '-date' && '\u2193'}
        </Button>}
        {searchInput!==''&&keywordType==="search"&&<Button
            type="text"
            style={{ fontSize: '13px', color: '#888' }}
            onClick={ () => {
                if (sortType !== '-rank') {
                    dispatch(
                        searchPgUserInputsS.actions.setSortType('-rank')
                    );
                }
            }}>
            Sort by relevance {sortType === '-rank' && '\u2193'}
        </Button>} */}

        <Button
            className="sub-heading-font"
            type="text"
            style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
            onClick={ () => {
                if (sortType !== '-date') {
                    dispatch(
                        searchPgUserInputsS.actions.setSortType('-date')
                    );
                }
            }}>
            Sort by date {sortType === '-date' && '\u2193'}
        </Button>
        <Button
            className="sub-heading-font"
            type="text"
            style={{ fontSize: '13px', color: '#888', marginBottom: 4 }}
            onClick={ () => {
                if (sortType !== '-altmetric_score') {
                    dispatch(
                        searchPgUserInputsS.actions.setSortType('-altmetric_score')
                    );
                }
            }}>
            Sort by Altmetric score {sortType === '-altmetric_score' && '\u2193'}
        </Button>







        {status!=="failed"&&<List
            loading={status==="idle"}
            itemLayout="horizontal"
            loadMore={
                hasNext ? <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button
                        className="sub-heading-font"
                        onClick={() => dispatch(pubTabThunks.loadMore())}
                    >
                        More
                    </Button>
                </div> : null
            }
            dataSource={pubList}
            renderItem={ item => {
                const pub = item.item as T.Publication;
                return <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                        <List.Item.Meta

                            avatar={<div
                                    className='altmetric-embed'
                                    data-badge-type='donut'
                                    data-badge-popover="right"
                                    data-link-target='_blank'
                                    data-doi={pub?.DOI||"0"}
                                ></div>}

                            title={ <PublicationTitle publication={pub}/> }

                            description={ <PublicationDescription publication={pub}/> }

                        />
                    </Skeleton>
                </List.Item>;
            } }
        />}
        
        { status==="failed"&&<Error500/> }




    </>;
}